class PredictiveSearchSwiper {
  constructor() {
    this.init();
  }

  init() {
    this.observePredictiveSearch();
  }

  observePredictiveSearch() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const predictiveSearch = mutation.target;
          if (predictiveSearch.hasAttribute('open')) {
            this.initHorizontalScroll(predictiveSearch);
            this.addHeaderClass();
          } else {
            this.removeHeaderClass();
          }
        }
      });
    });

    document.querySelectorAll('predictive-search').forEach((element) => {
      observer.observe(element, { attributes: true });
    });

    this.observeSearchInputs();
  }

  initHorizontalScroll(predictiveSearchElement) {
    setTimeout(() => {
      const productsContainer = predictiveSearchElement.querySelector('.predictive-search__result-group:last-child');
      if (!productsContainer) {
        return;
      }

      const productsList = productsContainer.querySelector('#predictive-search-results-products-list');
      if (!productsList || productsList.children.length === 0) {
        return;
      }

      this.applyHorizontalScrollStyles(productsList);
      
      this.addProductEventListeners(productsList);
      
    }, 100);
  }

  applyHorizontalScrollStyles(productsList) {
    productsList.style.display = 'flex';
    productsList.style.overflowX = 'auto';
    productsList.style.overflowY = 'hidden';
    productsList.style.scrollSnapType = 'x mandatory';
    productsList.style.gap = '20px';
    productsList.style.paddingBottom = '10px';
    productsList.style.webkitOverflowScrolling = 'touch';
    
    productsList.style.scrollbarWidth = 'none';
    productsList.style.msOverflowStyle = 'none';
    
    const products = Array.from(productsList.children);
    const productCount = products.length;
    
    const productWidth = this.calculateProductWidth(productCount);
    
    products.forEach((product, index) => {
      product.style.flex = '0 0 auto';
      product.style.scrollSnapAlign = 'start';
      product.style.width = productWidth;
      product.style.minWidth = productWidth;
      
      const linkElement = product.querySelector('.predictive-search__item');
      if (linkElement) {
        linkElement.style.height = '100%';
        linkElement.style.display = 'flex';
        linkElement.style.flexDirection = 'column';
        
        const contentElement = linkElement.querySelector('.predictive-search__item-content');
        if (contentElement) {
          contentElement.style.display = 'flex';
          contentElement.style.flexDirection = 'column';
          contentElement.style.height = '100%';
          contentElement.style.justifyContent = 'space-between';
        }
        
        const imageElement = linkElement.querySelector('.predictive-search__image');
        if (imageElement) {
          imageElement.style.width = '100%';
          imageElement.style.height = '120px';
          imageElement.style.objectFit = 'cover';
          imageElement.style.borderRadius = '6px';
          imageElement.style.backgroundColor = 'rgba(var(--color-foreground), 0.04)';
          
          if (window.innerWidth <= 749) {
            imageElement.style.height = '100px';
          } else if (window.innerWidth >= 1200) {
            imageElement.style.height = '160px';
          }
        }
      }
    });

    const style = document.createElement('style');
    style.textContent = `
      #predictive-search-results-products-list::-webkit-scrollbar {
        display: none;
      }
    `;
    document.head.appendChild(style);
  }

  calculateProductWidth(productCount) {
    const containerWidth = window.innerWidth;
    
    if (containerWidth <= 749) {
      return 'calc(100% / 2)';
    }
    
    if (containerWidth <= 1199) {
      if (productCount <= 2) return '220px';
      if (productCount === 3) return 'calc(100% / 3.3)';
      if (productCount === 4) return 'calc(100% / 4.3)';
      if (productCount <= 6) return '160px';
      return 'calc(100% / 3.5)';
    }
    
    if (productCount <= 2) return '280px';
    if (productCount === 3) return 'calc(100% / 3.3)';
    if (productCount === 4) return 'calc(100% / 4.3)';
    if (productCount <= 6) return '200px';
    return 'calc(100% / 4.2)';
  }

  addProductEventListeners(productsList) {
    const handleProductClick = (event) => {
      event.stopPropagation();
      event.preventDefault();
      
      const predictiveSearch = document.querySelector('predictive-search');
      if (predictiveSearch) {
        predictiveSearch.isClickingProduct = true;
        setTimeout(() => {
          predictiveSearch.isClickingProduct = false;
        }, 300);
      }
      
      const searchInput = document.querySelector('predictive-search input[type="search"]');
      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 50);
      }
    };
    
    const handleResize = () => {
      const products = Array.from(productsList.children);
      const productCount = products.length;
      const newWidth = this.calculateProductWidth(productCount);
      
      products.forEach((product) => {
        product.style.width = newWidth;
        product.style.minWidth = newWidth;
      });
      
      const images = productsList.querySelectorAll('.predictive-search__image');
      images.forEach((image) => {
        if (window.innerWidth <= 749) {
          image.style.height = '100px';
        } else if (window.innerWidth >= 1200) {
          image.style.height = '160px';
        } else {
          image.style.height = '120px';
        }
      });
    };
    
    const productItems = productsList.querySelectorAll('.predictive-search__item');
    productItems.forEach((item) => {
      item.addEventListener('click', handleProductClick);
      item.addEventListener('mousedown', handleProductClick);
    });
    
    window.addEventListener('resize', handleResize);
    
    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch) {
      const originalRemoveEventListener = window.removeEventListener;
      window.removeEventListener = function(type, listener) {
        if (type === 'resize' && listener === handleResize) {
          return;
        }
        return originalRemoveEventListener.call(this, type, listener);
      };
    }
  }

  addHeaderClass() {
    const header = document.querySelector('header');
    if (header) {
      header.classList.add('megamenu-active');
    }
  }

  removeHeaderClass() {
    const header = document.querySelector('header');
    if (header) {
      header.classList.remove('megamenu-active');
    }
  }

  observeSearchInputs() {
    const searchInputs = document.querySelectorAll('input[type="search"], input[name="q"], .search__input');
    
    searchInputs.forEach((input) => {
      input.addEventListener('focus', () => {
        this.addHeaderClass();
      });
      
      input.addEventListener('blur', () => {
        setTimeout(() => {
          const predictiveSearch = document.querySelector('predictive-search[open]');
          if (!predictiveSearch) {
            this.removeHeaderClass();
          }
        }, 150);
      });
      
      input.addEventListener('input', () => {
        if (input.value.length > 0) {
          this.addHeaderClass();
        } else {
          setTimeout(() => {
            const predictiveSearch = document.querySelector('predictive-search[open]');
            if (!predictiveSearch && !input.matches(':focus')) {
              this.removeHeaderClass();
            }
          }, 100);
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.predictiveSearchSwiper = new PredictiveSearchSwiper();
}); 